import { useState } from 'react'

import { useAuthStore } from '@/stores/authStore'

import { suportaBiometria } from '../services/webauthn'

/** Se o convite deve aparecer: login com senha sem vínculo de biometria, em navegador com suporte. */
export function useOfertaBiometriaPendente(): boolean {
  const ofertar = useAuthStore((state) => state.ofertarBiometria)
  const [suportado] = useState(suportaBiometria)
  return ofertar && suportado
}
